import d from './Home.appsflyer-link-generator'
export default d
